import * as React from 'react';
import type { UploadedFile } from '@/types/echo_creation';
import { FileListItem } from './FileListItem';

interface FileDisplayListProps {
  files: UploadedFile[];
  onCancel: (id: string) => void;
  onRetry: (id: string) => void;
  onDelete: (id: string) => void;
  onToggleScreenshots?: (id: string, value: boolean) => void;
}

export const FileDisplayList: React.FC<FileDisplayListProps> = ({
  files,
  onCancel,
  onRetry,
  onDelete,
  onToggleScreenshots,
}) => (
  <div className='mb-8 w-full'>
    <h4 className='mb-4 font-sans text-20 font-medium leading-27 text-dark-100'>Uploaded Files</h4>

    {files.length === 0 ? (
      <p className='font-sans text-16 font-normal leading-27 text-gray-450'>
        No files have been uploaded
      </p>
    ) : (
      <div className='grid grid-cols-1 gap-4 lg:grid-cols-2'>
        {files.map((file) => (
          <FileListItem
            key={file.id}
            file={file}
            onCancel={onCancel}
            onRetry={onRetry}
            onDelete={onDelete}
            {...(onToggleScreenshots ? { onToggleScreenshots } : {})}
          />
        ))}
      </div>
    )}
  </div>
);
